import isEmpty from 'lodash/isEmpty';

const utmParamsKeys = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content'
];

const getUtmFromParams = (
  params: URLSearchParams
): { [p: string]: string } | undefined => {
  const utm: {
    [key: string]: string;
  } = {};

  params.forEach((val, key) => {
    if (utmParamsKeys.includes(key)) {
      const [, utmSubKey] = key.split('_');
      utm[utmSubKey] = val;
    }
  });

  return !isEmpty(utm) ? utm : undefined;
};

const queryParamsUtils = { getUtmFromParams };

export default queryParamsUtils;
